import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/features";

// Public: { [key]: enabled } — used to show/hide feature-gated UI.
const publicFlags = () => axios.get(`${API_URL}/public`);

// Admin.
const getAll = () => axios.get(API_URL, { headers: authHeader() });
const setEnabled = (key, enabled) =>
  axios.put(`${API_URL}/${key}`, { enabled }, { headers: authHeader() });

const FeatureService = { publicFlags, getAll, setEnabled };

export default FeatureService;
